import { Trans } from '@lingui/macro';
import { Container, StyledText } from './styled';
export function NoResults() {
    return (<Container>
      <StyledText size="tiny" appearance="neutral">
        <Trans comment="Global search no items found text">No items match your search.</Trans>
      </StyledText>
    </Container>);
}
